import React from 'react';

interface Props {
  searchInput: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  className: string;
}

function SearchBox({ searchInput, handleInputChange, placeholder, className }: Props) {
  return (
    <div>
      <input
        type="text"
        value={searchInput}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={className}
      />
    </div>
  );
}

export default SearchBox;
